module.exports = __webpack_public_path__ + "media/3x/6-72cac1ff.png";